import type { ResourceType } from "@ext/git/actions/Publish/logic/ExactResourceViewWithContent";
import { IMG_FILE_TYPES, KNOWN_TEXT_EXTENSIONS } from "@ext/git/actions/Publish/model/consts";
import { getDiagramTypeByExtension } from "@ext/markdown/elements/diagrams/logic/diagramDescriptors";

const resolveResourceTypeByExtension = (extension: string): ResourceType => {
	if (IMG_FILE_TYPES.includes(extension)) {
		return "image";
	}

	if (getDiagramTypeByExtension(extension)) {
		return "diagram";
	}

	if (KNOWN_TEXT_EXTENSIONS.includes(extension)) {
		return "text";
	}

	return "unknown";
};

export default resolveResourceTypeByExtension;
